import React from 'react';

import formStyles from './form.module.css';

const FormItem = ({ children, style }) => <div className={formStyles.formItem} style={style}>{children}</div>;

export default FormItem;
